import './lib/sentry';
import '@sea-snag/ui/globals.css';
import './index.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { queryClient } from './lib/query-client';
import { reloadForNewBuild } from './lib/stale-build';
import { routeTree } from './routeTree.gen';

const router = createRouter({ routeTree });

// A page left open across a deploy can't load the next screen's code, which
// the deploy removed: reload to pick up the new build.
window.addEventListener('vite:preloadError', (event) => {
  // Reading sessionStorage throws in some browsers when storage is blocked.
  // Without it the page never reloads, and the error shows as before.
  let storage: Storage;
  try {
    storage = window.sessionStorage;
  } catch {
    return;
  }
  reloadForNewBuild(event, storage, () => window.location.reload());
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>
);
